// extracted by mini-css-extract-plugin
export default {"container":"Jp4CB","light":"lIzTL","dark":"bYvbI"};